import { Banner } from '@ordr-as/umami-react'
import { useState } from 'react'
import { PaymentEventDto, PaymentOpsPaymentEventDto, TerminalEventDto } from '../../../generated-api'
import { ToggleSwitch } from 'components/Toggle'
import JsonHighlight from 'components/JsonHighlight'
import { PayloadWrapper } from './PayloadWrapper'
import PspRequestsResponses from 'pages/paymentDetails/eventsTab/PspRequestsResponses'
import { formatJSONKeys } from 'utils/stringUtils'

const Payload = ({ event }: { event: PaymentEventDto | TerminalEventDto | PaymentOpsPaymentEventDto }) => {
    const [isJsonView, setIsJsonView] = useState(false)

    if (!event.payload) {
        return (
            <Banner kind="warn" stretch="parent" onClose={() => null}>
                No payload found for event
            </Banner>
        )
    }
    const parsedPayload = JSON.parse(event.payload)
    if (isJsonView) {
        return (
            <>
                <div className="px-4 truncate">
                    <div className="flex justify-between mb-4">
                        <h2>Event payload</h2>
                        <ToggleSwitch label="Toggle view" checked={isJsonView} onChange={setIsJsonView} />
                    </div>
                    <JsonHighlight object={parsedPayload} />
                </div>
            </>
        )
    }

    return (
        <div className="px-4 truncate">
            <div className="flex justify-between mb-4">
                <h2>Event payload</h2>
                <ToggleSwitch label="Toggle view" checked={isJsonView} onChange={setIsJsonView} />
            </div>
            <div>
                {Object.entries(parsedPayload).map(([key, value], idx: number) => (
                    <div
                        key={idx}
                        className={`${
                            idx !== Object.entries(parsedPayload).length - 1
                                ? 'border-b border-grey-lightest'
                                : 'border-0'
                        }`}
                    >
                        <PayloadWrapper label={formatJSONKeys(key)} value={value as string} />
                    </div>
                ))}
            </div>
            {(event as PaymentEventDto).pspRequestsResponses &&
                (event as PaymentEventDto).pspRequestsResponses.length > 0 && (
                    <PspRequestsResponses requestsAndResponses={(event as PaymentEventDto).pspRequestsResponses} />
                )}
        </div>
    )
}

export default Payload
